export const isCompanyEmail = (email) => {
  if (!email) return false;

  const blacklist = process?.env?.RAZZLE_RUNTIME_BLACKLIST_DOMAINS?.split(',') ?? [];
  const emailSplit = email.split('@');
  const domain = emailSplit[emailSplit.length - 1];
  const domainSplit = domain.split('.');
  const domainToValidate = domainSplit[0]?.toLowerCase();
  return !blacklist.includes(domainToValidate);
};

export const errorsReasonSendgrid = [
  'Bounced Address',
  'Receiving server temporarily rejected the message',
  '500 unknown recipient',
];

export const styleEmailPreviewListItems = (previewDiv) => {
  if (!previewDiv) return;

  const listItems = previewDiv.getElementsByTagName('li');
  Array.from(listItems).forEach((li) => {
    li.style.marginLeft = '20px';
    li.style.listStylePosition = 'inside';
  });
};

export function isValidEmail(email) {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
}

/**
 * Validates if an email belongs to the @alkemy.org domain
 * @param {string} email - The email address to validate
 * @returns {boolean} True if the email ends with @alkemy.org, false otherwise
 */
export function isAlkemyEmail(email) {
  if (!email || typeof email !== 'string') return false;
  return email.trim().toLowerCase().endsWith('@alkemy.org');
}

/**
 * Translates HTML template by replacing translation keys with their values
 * @param {string} html - The HTML template string
 * @param {string} lang - The language code (default: 'es')
 * @param {object} template - The email template object containing translations
 * @returns {string} The translated HTML
 */
export const translateTemplateHTML = (html, lang = 'es', template) => {
  if (!html) return '';
  if (!template?.translations) return html;

  let translation = template.translations[lang];

  if (!translation) {
    const availableKeys = Object.keys(template.translations || {});
    if (availableKeys.length > 0) {
      translation = template.translations[availableKeys[0]];
    }
  }

  if (!translation) return html;

  let translatedHtml = html;
  for (const [key, value] of Object.entries(translation)) {
    if (value == null) continue;
    translatedHtml = translatedHtml.replace(new RegExp(`{{${key}}}`, 'g'), value);
  }

  return translatedHtml;
};

/**
 * Translates a specific label from the email template
 * @param {string} label - The label key to translate
 * @param {string} lang - The language code (default: 'es')
 * @param {object} template - The email template object containing translations
 * @returns {string} The translated label or original label if not found
 */
export const translateTemplateLabel = (label, lang = 'es', template) => {
  if (!label) return '';
  if (!template?.translations) return label;

  if (template.translations[lang] && template.translations[lang][label] != null) {
    return template.translations[lang][label];
  }

  const availableKeys = Object.keys(template.translations || {});
  for (const availableLang of availableKeys) {
    if (
      template.translations[availableLang] &&
      template.translations[availableLang][label] != null
    ) {
      return template.translations[availableLang][label];
    }
  }

  return label;
};
